import { z } from "zod";
import { TObjectBase, TApiObjectBase } from "../base";

export type IRawCompanyMember = z.infer<typeof TRawCompanyMember>;
export const TRawCompanyMember = z
  .object({
    admin: z.boolean(),
    hasAutoAccess: z.boolean().optional(),
  })
  .extend(TObjectBase.shape);

export type IApiCompanyMember = z.infer<typeof TApiCompanyMember>;
export const TApiCompanyMember = z
  .object({
    admin: z.boolean(),
    hasAutoAccess: z.boolean().optional(),
  })
  .extend(TApiObjectBase.shape);
